import React, { useEffect, useState } from "react";
import { Button, Typography } from "@mui/material";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import icon from "../assets/icons/LoginIcon.png";
import { PhoneInput } from "react-international-phone";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { getCountryCallingCode } from "react-phone-number-input";
import CountrySelect from "../utils/countrySelect";
import { subscribeToAllOrganizations } from "../utils/pushNotifications";

/* ---------- Direction C tokens (styling only) ---------- */
const FONT = "'Plus Jakarta Sans', system-ui, -apple-system, sans-serif";
const MONO = "'IBM Plex Mono', ui-monospace, monospace";
const INK = "#0F1B2A";
const INK_2 = "#3D4C60";
const MUTED = "#66748A";
const LINE = "#E4E9EF";
const FIELD_EDGE = "#D5DEE7";
const PRIMARY = "#0B5C8A";
const PRIMARY_DARK = "#084767";

// Scoped styles: layout, focus rings and resets for global App.css rules
// (.App, .border-container, form, .phone-container, .styled-input ...).
const LOGIN_CSS = `
.dc-login{position:relative;min-height:100dvh;display:grid;grid-template-columns:minmax(0,1.05fr) minmax(0,1fr);background:#FFFFFF;font-family:${FONT};color:${INK};text-align:left;box-sizing:border-box;}
.dc-login *{box-sizing:border-box;}
.dc-login.App{padding:0!important;margin:0!important;}

/* ---- brand panel ---- */
.dc-login .dc-brand{position:relative;overflow:hidden;display:flex;flex-direction:column;justify-content:space-between;padding:40px 48px;color:#FFFFFF;
  background:radial-gradient(120% 90% at 0% 0%, #13729F 0%, ${PRIMARY} 38%, #0A3F5E 72%, ${INK} 100%);}
.dc-login .dc-brand::before{content:"";position:absolute;inset:0;pointer-events:none;
  background-image:linear-gradient(rgba(255,255,255,.06) 1px,transparent 1px),linear-gradient(90deg,rgba(255,255,255,.06) 1px,transparent 1px);
  background-size:44px 44px;mask-image:radial-gradient(90% 80% at 30% 20%,#000 20%,transparent 75%);-webkit-mask-image:radial-gradient(90% 80% at 30% 20%,#000 20%,transparent 75%);}
.dc-login .dc-brand::after{content:"";position:absolute;width:520px;height:520px;right:-180px;bottom:-200px;border-radius:50%;
  background:radial-gradient(circle,rgba(47,168,100,.28),transparent 65%);pointer-events:none;}
.dc-login .dc-brand > *{position:relative;z-index:1;}
.dc-login .dc-feature{display:flex;gap:12px;align-items:flex-start;padding:12px 0;border-top:1px solid rgba(255,255,255,.12);}
.dc-login .dc-feature:first-child{border-top:0;}
.dc-login .dc-ico{flex:0 0 30px;width:30px;height:30px;border-radius:9px;display:flex;align-items:center;justify-content:center;
  background:rgba(255,255,255,.1);border:1px solid rgba(255,255,255,.16);font-family:${MONO};font-size:12px;font-weight:600;}
.dc-login .dc-preview{margin-top:28px;max-width:420px;padding:14px;border-radius:14px;background:rgba(255,255,255,.08);
  border:1px solid rgba(255,255,255,.14);backdrop-filter:blur(6px);-webkit-backdrop-filter:blur(6px);}
.dc-login .dc-bar{height:8px;border-radius:999px;background:rgba(255,255,255,.14);overflow:hidden;}
.dc-login .dc-bar > span{display:block;height:100%;border-radius:999px;}

/* ---- form panel ---- */
.dc-login .dc-panel{display:flex;flex-direction:column;align-items:center;justify-content:center;padding:40px 24px;background:#FFFFFF;}
.dc-login .border-container{width:100%!important;max-width:400px!important;height:auto!important;min-height:0!important;margin:0!important;padding:0!important;
  background:transparent!important;border:0!important;border-radius:0!important;box-shadow:none!important;text-align:left!important;}
.dc-login form{width:100%!important;max-width:none!important;height:auto!important;min-height:0!important;margin:0!important;padding:0!important;
  background:transparent!important;border:0!important;box-shadow:none!important;}
.dc-login label.dc-lbl{display:block!important;width:auto!important;margin:0 0 6px!important;font-family:${FONT}!important;font-size:12.5px!important;font-weight:600!important;color:${INK_2}!important;}

/* one field frame for phone + password: border, hover and focus ring */
.dc-login .dc-field{display:flex!important;align-items:center;width:100%!important;height:46px!important;margin:0 0 16px!important;padding:0!important;
  background:#F8FAFC!important;border:1px solid ${FIELD_EDGE}!important;border-radius:11px!important;overflow:hidden;position:relative;
  transition:border-color .15s, box-shadow .15s, background .15s;}
.dc-login .dc-field:hover{border-color:#B4C6DA!important;}
.dc-login .dc-field:focus-within{background:#FFFFFF!important;border-color:${PRIMARY}!important;box-shadow:0 0 0 4px rgba(11,92,138,.12)!important;}
.dc-login .dc-field input{flex:1 1 auto;min-width:0;width:auto!important;height:100%!important;margin:0!important;padding:0 14px!important;border:0!important;outline:none!important;
  background:transparent!important;box-shadow:none!important;font-family:${FONT}!important;font-size:14.5px!important;color:${INK}!important;}
.dc-login .dc-field input::placeholder{color:#8A97A8;opacity:1;}
.dc-login .dc-cc{flex:0 0 auto;display:flex;align-items:center;height:100%;padding:0 6px 0 12px;border-right:1px solid ${FIELD_EDGE};}
.dc-login .dc-cc *{font-family:${FONT}!important;font-size:14px!important;color:${INK};}
.dc-login .toggle-icon{position:static!important;flex:0 0 46px;width:46px;height:100%;display:flex!important;align-items:center;justify-content:center;
  cursor:pointer;color:#8A97A8;transform:none!important;}
.dc-login .toggle-icon:hover{color:${INK_2};}
.dc-login a.dc-link{font-family:${FONT};font-size:13px;font-weight:600;text-decoration:none;}
.dc-login a.dc-link:hover{text-decoration:underline;text-underline-offset:3px;}

/* ---- responsive: stack on tablets / phones ---- */
@media (max-width: 960px){
  .dc-login{grid-template-columns:minmax(0,1fr);background:#F4F7FA;}
  .dc-login .dc-brand{display:none;}
  .dc-login .dc-panel{background:transparent;padding:32px 16px;}
  .dc-login .dc-card{background:#FFFFFF;border:1px solid ${LINE};border-radius:18px;padding:28px 22px 24px;box-shadow:0 24px 48px -28px rgba(15,27,42,.28);}
  .dc-login .dc-mobile-logo{display:flex!important;}
}
`;

const FEATURES = [
  { n: "01", t: "Every lead in one place", d: "Capture, assign and track leads across all your projects." },
  { n: "02", t: "Never miss a follow-up", d: "Reminders and today's tasks keep your team on schedule." },
  { n: "03", t: "Built for your team", d: "Roles for admins, project heads, sales and partners." },
];

const Login = () => {
  const [data, setData] = useState();
  const navigate = useNavigate();
  const [error, setError] = useState();
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const [viewPass, setViewPass] = useState(false);
  const [country, setCountry] = useState("IN");
  const handleViewPass = () => setViewPass(!viewPass);
  const [role, setRole] = useState();

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user")) || null;
    const params = new URLSearchParams(location.search);
    const redirect = params.get("redirect");
    if (user && !redirect) {
      if (user.accessToken && user.userRole[0] === "ADMIN") {
        navigate("/dashboard");
      } else if (user.accessToken && user.userRole[0] === "SUPERADMIN") {
        navigate("/superadmin-dashboard");
      } else if (user.accessToken) {
        navigate("/dashboard");
      }
    }
  }, [location.search]);

  const handleChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  const handleLogin = async () => {
    const params = new URLSearchParams(location.search);
    let redirect = params.get("redirect");
    setLoading(true);
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/auth/signin`,
        {
          username: `${getCountryCallingCode(country)}${data.username.replace(/\D/g, "")}`,
          password: data.password,
        },
      );

      if (res.data.userRole[0] === "SUPERADMIN") {
        navigate("/superadmin-dashboard");
      } else if (res.data.userRole[0] === "ADMIN") {
        try {
          const orgs = await axios.get(
            `${process.env.REACT_APP_BACKEND_URL}/org-user/get-all-org?username=${res.data.username}`,
            {
              headers: {
                Authorization: `Bearer ${res.data.accessToken}`,
              },
            },
          );
          if (orgs.data.length > 0) {
            localStorage.setItem("org", JSON.stringify(orgs.data[0].orgId));
            subscribeToAllOrganizations(orgs.data.map((o) => o.orgId)).catch(
              (err) => console.log("Push subscription failed:", err),
            );
          }
        } catch (error) {
          console.log(error);
        }
        if (redirect) {
          navigate(
            redirect.includes("/dashboard")
              ? redirect.replace("/dashboard", "/dashboard")
              : redirect.includes("/dashboard/L")
                ? redirect.replace("/dashboard", "/dashboard/lead")
                : redirect,
          );
        } else {
          navigate(`/dashboard`);
        }
      } else if (res.data.userRole[0] === "PARTNER") {
        navigate("/partner");
      } else {
        try {
          const orgs = await axios.get(
            `${process.env.REACT_APP_BACKEND_URL}/org-user/get-all-org?username=${res.data.username}`,
            {
              headers: {
                Authorization: `Bearer ${res.data.accessToken}`,
              },
            },
          );
          if (orgs.data.length > 0) {
            localStorage.setItem("org", JSON.stringify(orgs.data[0].orgId));
            subscribeToAllOrganizations(orgs.data.map((o) => o.orgId)).catch(
              (err) => console.log("Push subscription failed:", err),
            );
          }
        } catch (error) {
          console.log(error);
        }
        if (redirect) {
          navigate(
            redirect.includes("/dashboard")
              ? redirect.replace("/dashboard", "/dashboard")
              : redirect.includes("/dashboard/lead")
                ? redirect.replace("/dashboard/lead", "/dashboard")
                : redirect,
          );
        } else {
          navigate("/dashboard");
        }
      }
      localStorage.setItem("user", JSON.stringify(res.data));
    } catch (error) {
      setError("Login failed. Invalid user ID or password.");
    } finally {
      setLoading(false);
    }
  };

  // Pressing Enter in either field logs in (same handler as the button).
  const onFormSubmit = (e) => {
    e.preventDefault();
    if (!loading) handleLogin();
  };

  const logoTile = (size = 40) => (
    <div
      style={{
        width: size,
        height: size,
        flex: `0 0 ${size}px`,
        borderRadius: Math.round(size * 0.28),
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: PRIMARY,
        boxShadow: "0 8px 18px -8px rgba(11,92,138,.6)",
      }}
    >
      <img src={icon} alt="Login icon" style={{ width: size * 0.5, height: size * 0.5, objectFit: "contain" }} />
    </div>
  );

  return (
    <>
      <style>{LOGIN_CSS}</style>
      <div className="App dc-login">
        {loading && <div className="loading-div"></div>}

        {/* ================= BRAND PANEL (desktop) ================= */}
        <aside className="dc-brand" aria-hidden="true">
          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <div
              style={{
                width: 40,
                height: 40,
                borderRadius: 11,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "rgba(255,255,255,.12)",
                border: "1px solid rgba(255,255,255,.2)",
              }}
            >
              <img src={icon} alt="" style={{ width: 20, height: 20, objectFit: "contain" }} />
            </div>
            <span style={{ fontSize: 15, fontWeight: 700, letterSpacing: "-0.01em" }}>Real Estate CRM</span>
          </div>

          <div style={{ maxWidth: 460 }}>
            <div
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: 8,
                height: 28,
                padding: "0 12px",
                borderRadius: 999,
                background: "rgba(255,255,255,.1)",
                border: "1px solid rgba(255,255,255,.18)",
                fontFamily: MONO,
                fontSize: 11,
                fontWeight: 500,
                letterSpacing: "0.1em",
                textTransform: "uppercase",
                marginTop: 10,
              }}
            >
              <span style={{ width: 6, height: 6, borderRadius: "50%", background: "#5EE0A0" }} />
              Sales workspace
            </div>
            <h2
              style={{
                margin: "18px 0 12px",
                fontSize: 38,
                lineHeight: 1.12,
                fontWeight: 800,
                letterSpacing: "-0.035em",
                textWrap: "balance",
              }}
            >
              Every lead, every follow-up, one place.
            </h2>
            <p style={{ margin: 0, fontSize: 15, lineHeight: 1.6, color: "rgba(255,255,255,.78)", maxWidth: 420 }}>
              Manage projects, teams and your sales pipeline from a single dashboard.
            </p>

            <div style={{ marginTop: 28, maxWidth: 420 }}>
              {FEATURES.map((f) => (
                <div className="dc-feature" key={f.n}>
                  <span className="dc-ico">{f.n}</span>
                  <div>
                    <div style={{ fontSize: 14, fontWeight: 700 }}>{f.t}</div>
                    <div style={{ marginTop: 2, fontSize: 13, lineHeight: 1.5, color: "rgba(255,255,255,.7)" }}>{f.d}</div>
                  </div>
                </div>
              ))}
            </div>

            {/* decorative pipeline preview (no data) */}
            <div className="dc-preview">
              <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 12, fontSize: 11, fontFamily: MONO, letterSpacing: "0.1em", textTransform: "uppercase", color: "rgba(255,255,255,.7)" }}>
                <span>Pipeline</span>
                <span>This week</span>
              </div>
              {[
                { l: "New", w: "86%", c: "#7CC4F0" },
                { l: "Site visit", w: "62%", c: "#9C8CF5" },
                { l: "Negotiation", w: "40%", c: "#F2B45A" },
                { l: "Won", w: "24%", c: "#5EE0A0" },
              ].map((b) => (
                <div key={b.l} style={{ display: "grid", gridTemplateColumns: "88px 1fr", alignItems: "center", gap: 10, marginTop: 8 }}>
                  <span style={{ fontSize: 12, color: "rgba(255,255,255,.8)" }}>{b.l}</span>
                  <div className="dc-bar">
                    <span style={{ width: b.w, background: b.c }} />
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div style={{ fontSize: 12, color: "rgba(255,255,255,.55)" }}>
            © {new Date().getFullYear()} · All rights reserved
          </div>
        </aside>

        {/* ================= FORM PANEL ================= */}
        <main className="dc-panel">
          <div className="border-container">
            <div className="dc-card">
              <form onSubmit={onFormSubmit} noValidate>
                {/* logo on small screens (brand panel hidden) */}
                <div className="dc-mobile-logo" style={{ display: "none", marginBottom: 18 }}>
                  {logoTile(44)}
                </div>

                <Typography
                  variant="h4"
                  component="h1"
                  sx={{ m: 0, fontFamily: FONT, fontSize: { xs: 26, sm: 30 }, fontWeight: 800, letterSpacing: "-0.03em", lineHeight: 1.15, color: INK }}
                >
                  Welcome back
                </Typography>
                <Typography
                  component="p"
                  sx={{ mt: 1, mb: 3.5, fontFamily: FONT, fontWeight: 500, color: "#4A5A6E", fontSize: 14.5, lineHeight: 1.55 }}
                >
                  Log in to your Real Estate Dashboard
                </Typography>

                <label htmlFor="username" className="dc-lbl">Mobile number</label>
                <div className="phone-container dc-field">
                  <div className="dc-cc">
                    <CountrySelect value={country} onChange={(c) => setCountry(c)} />
                  </div>
                  <input
                    type="tel"
                    id="username"
                    name="username"
                    inputMode="numeric"
                    autoComplete="tel-national"
                    placeholder="Enter mobile number"
                    onChange={(e) =>
                      setData((prev) => ({ ...prev, username: e.target.value }))
                    }
                  />
                </div>

                <div style={{ display: "flex", alignItems: "baseline", justifyContent: "space-between", gap: 8 }}>
                  <label htmlFor="newPassword" className="dc-lbl">Password</label>
                  <a href="/forgot-password" className="dc-link" style={{ fontSize: 12.5, color: PRIMARY, marginBottom: 6 }}>
                    Forgot password?
                  </a>
                </div>
                <div className="input-wrapper dc-field" style={{ marginBottom: error ? 12 : 22 }}>
                  <input
                    type={viewPass ? "text" : "password"}
                    name="newPassword"
                    id="newPassword"
                    autoComplete="current-password"
                    placeholder="Enter your password"
                    onChange={(e) =>
                      setData((prev) => ({ ...prev, password: e.target.value }))
                    }
                    className="styled-input"
                  />
                  <span
                    className="toggle-icon"
                    onClick={handleViewPass}
                    role="button"
                    aria-label={viewPass ? "Hide password" : "Show password"}
                    title={viewPass ? "Hide password" : "Show password"}
                  >
                    {viewPass ? <VisibilityOffIcon sx={{ fontSize: 20 }} /> : <VisibilityIcon sx={{ fontSize: 20 }} />}
                  </span>
                </div>

                {error && (
                  <span
                    className="error"
                    role="alert"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 8,
                      margin: "0 0 18px",
                      padding: "10px 12px",
                      background: "#FBEDEB",
                      border: "1px solid #F2CFCA",
                      borderRadius: 10,
                      fontFamily: FONT,
                      fontSize: 13,
                      fontWeight: 500,
                      color: "#A6342A",
                    }}
                  >
                    <span
                      style={{
                        flex: "0 0 18px",
                        width: 18,
                        height: 18,
                        borderRadius: "50%",
                        background: "#C42B24",
                        color: "#FFFFFF",
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: 12,
                        fontWeight: 800,
                      }}
                    >
                      !
                    </span>
                    {error}
                  </span>
                )}

                <Button
                  className="btn-contained"
                  type="submit"
                  fullWidth
                  disabled={loading}
                  sx={{
                    height: "48px !important",
                    minHeight: "48px !important",
                    margin: "0 !important",
                    borderRadius: "11px !important",
                    background: `${PRIMARY} !important`,
                    color: "#FFFFFF !important",
                    border: "0 !important",
                    fontFamily: FONT,
                    fontSize: 15,
                    fontWeight: 700,
                    textTransform: "none",
                    boxShadow: "0 10px 22px -12px rgba(11,92,138,.7)",
                    transition: "background .15s, box-shadow .15s, transform .05s",
                    "&:hover": { background: `${PRIMARY_DARK} !important`, boxShadow: "0 12px 26px -12px rgba(11,92,138,.8)" },
                    "&:active": { transform: "translateY(1px)" },
                    "&.Mui-disabled": { opacity: 0.65, color: "#FFFFFF !important" },
                  }}
                >
                  {loading ? "Logging in..." : "Log in"}
                </Button>

                <div style={{ display: "flex", alignItems: "center", gap: 12, margin: "24px 0 18px", color: MUTED, fontSize: 12 }}>
                  <span style={{ flex: 1, height: 1, background: LINE }} />
                  New here?
                  <span style={{ flex: 1, height: 1, background: LINE }} />
                </div>

                <a
                  href="/register-org"
                  className="dc-link"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: 8,
                    height: 46,
                    border: `1px solid ${FIELD_EDGE}`,
                    borderRadius: 11,
                    background: "#FFFFFF",
                    color: INK,
                    fontSize: 14,
                  }}
                >
                  Register your organization
                  <span
                    style={{
                      padding: "2px 8px",
                      borderRadius: 999,
                      background: "#E9F7EE",
                      border: "1px solid #C4E8D2",
                      color: "#1B6B41",
                      fontSize: 11,
                      fontWeight: 700,
                      letterSpacing: "0.04em",
                    }}
                  >
                    FREE
                  </span>
                </a>
              </form>
            </div>
          </div>
        </main>
      </div>
    </>
  );
};

export default Login;